import { render, staticRenderFns } from "./LookBookGoodsEdit.vue?vue&type=template&id=5b93554d&"
import script from "./LookBookGoodsEdit.vue?vue&type=script&lang=js&"
export * from "./LookBookGoodsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports